import Vue from "vue";

import Fragment from "vue-fragment";
Vue.use(Fragment.Plugin);

import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents);

import VueShowdown from "vue-showdown";
Vue.use(VueShowdown);

import App from "./App.vue";
import router from "./router";

import "@/assets/scss/style.scss";

Vue.config.productionTip = false;

Vue.filter("asCurrency", function(value) {
  return parseInt(value).toLocaleString();
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
